//messages.js
export default {
    product_id: "Product",
    product_name: "Product Name",
    specific_gravity: "Specific Gravity",
    total_sensors: "Total Sensors",
};
